import {
	endpointsMap,
	IGetLoyaltyWalletOptions,
	IGetLoyaltyWalletResponse,
	IGetLoyaltyActivitiesOptions,
	IGetLoyaltyActivitiesResponse,
	IGetLoyaltyProfileOptions,
	IGetLoyaltyProfileResponse,
	IJoinToLoyaltyOptions,
	IJoinToLoyaltyResponse
} from './ICustomShopperLoyalty';

import AbstractCustomShopperAPI from '../AbstractCustomShopperAPI';
import {ICustomApiConfig} from '../ICustomApiConfig';

/**
 * Represents CustomShopperLoyalty
 */
class CustomShopperLoyalty extends AbstractCustomShopperAPI {
	/**
	 * @constructor
	 * @param {ICustomApiConfig} config - API Config
	 */
	constructor(config: ICustomApiConfig) {
		super(config);
	}

	/**
	 * Gets customer's loyalty wallet
	 * @param {IGetLoyaltyWalletOptions} fetchOptions - options to pass to API Call
	 * @param {boolean} throwOnError - throw error if api returns error
	 *
	 * @returns {IGetLoyaltyWalletResponse} - Customer's Loyalty wallet
	 */
	public async getLoyaltyWallet(fetchOptions: IGetLoyaltyWalletOptions, throwOnError?: boolean): Promise<IGetLoyaltyWalletResponse> {
		const response: IGetLoyaltyWalletResponse = await this.callCustomEndpoint<IGetLoyaltyWalletResponse>(
			fetchOptions,
			endpointsMap.GET_WALLET
		);

		if (throwOnError && !response.loyaltyWallet) {
			throw new Error('No wallet returned.');
		}

		return response;
	}

	/**
	 * Gets loyalty activities
	 * @param {IGetLoyaltyActivitiesOptions} fetchOptions - options to pass to API Call
	 * @param {boolean} throwOnError - throw error if api returns error
	 *
	 * @returns {IGetLoyaltyActivitiesResponse} - Array of Customer's Loyalty activities
	 */
	public async getLoyaltyActivities(
		fetchOptions: IGetLoyaltyActivitiesOptions,
		throwOnError?: boolean
	): Promise<IGetLoyaltyActivitiesResponse> {
		const response: IGetLoyaltyActivitiesResponse = await this.callCustomEndpoint<IGetLoyaltyActivitiesResponse>(
			fetchOptions,
			endpointsMap.GET_ACTIVITIES
		);

		if (throwOnError && !response.loyaltyActivities) {
			throw new Error('No activities returned.');
		}

		return response;
	}

	/**
	 * Gets the loyalty profile
	 * @param {IGetLoyaltyProfileOptions} fetchOptions - options to pass to API Call
	 * @param {boolean} throwOnError - throw error if api returns error
	 *
	 * @returns {IGetLoyaltyProfileResponse} - Customer's Loyalty profile
	 */
	public async getLoyaltyProfile(fetchOptions: IGetLoyaltyProfileOptions, throwOnError?: boolean): Promise<IGetLoyaltyProfileResponse> {
		const response: IGetLoyaltyProfileResponse = await this.callCustomEndpoint<IGetLoyaltyProfileResponse>(
			fetchOptions,
			endpointsMap.GET_PROFILE
		);

		if (throwOnError && !response.loyaltyProfile) {
			throw new Error('No profile returned.');
		}

		return response;
	}

	/**
	 * Joins the customer to the loyalty program
	 * @param {IGetLoyaltyProfileOptions} fetchOptions - options to pass to API Call
	 * @param {boolean} throwOnError - throw error if api returns error
	 *
	 * @returns {IJoinToLoyaltyResponse} - Status of joins request
	 */
	public async joinToLoyalty(fetchOptions: IJoinToLoyaltyOptions, throwOnError?: boolean): Promise<IJoinToLoyaltyResponse> {
		const response: IJoinToLoyaltyResponse = await this.callCustomEndpoint<IJoinToLoyaltyResponse>(
			fetchOptions,
			endpointsMap.JOIN_LOYALTY
		);

		if (throwOnError && (response.status !== 'JOINED' && response.status !== 'ALREADY_JOINED')) {
			throw new Error('Join failed.');
		}

		return response;
	}
}

export default CustomShopperLoyalty;
